<template>
  <div class="box">
    <div class="isTit">训练营证书</div>
    <div class="rotograph">
      <div class="oneBox" v-if="!isShow">
        <div
          v-for="(item, index) in propsData"
          :key="index"
          class="oneItemBox"
          @click="itemImgClick(item, index)"
        >
          <img :src="item.imgUrl" />
        </div>
      </div>
      <!-- 超过五张以上或者只有三张显示 -->
      <div class="box" v-else>
        <div
          v-for="(item, index) in imgList"
          :key="index"
          class="itemBox"
          @click="itemImgClick(item, index)"
        >
          <img :src="item.imgUrl" />
        </div>
        <div class="left" @click="left">减</div>
        <div class="right" @click="right">加</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [],
      default: [
        {
          imgUrl:
            "https://img2.baidu.com/it/u=4207579190,2326259485&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=8d3103582ee19fba50e1fc95b5eabc2d",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=2263144951,1297168195&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1676394000&t=e18bc972499c8c2549001a734e72e137",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box {
  .isTit {
    font-size: 24px;
    font-family: MicrosoftYaHei-Bold-, MicrosoftYaHei-Bold;
    font-weight: normal;
    color: #333333;
    margin-bottom: 37px;
  }
  .rotograph {
    height: 566px;
    background-color: #fff;
  }
}
</style>